import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisResourcePropertyDisplayInputs } from '../../model/his-resource-property-display.model';
import { ResourcePropertyDetail } from '../../model/resource-property-detail.model';
import { HisResourcePropertyDisplayService } from '../../service/his-resource-property-display.service';

/**
 * Renders the icon a resource category is presented with next to the filename, and nothing at
 * all for a category without such an icon.
 *
 * This is the Angular counterpart of the JSF {@code selectFile-metadata-icon.xhtml}: instead
 * of switching on the category key it looks the icon up in the
 * {@link HisResourcePropertyDisplayService}.
 */
@Component( {
    standalone: false,
    selector: 'his-select-file-metadata-icon',
    templateUrl: './his-select-file-metadata-icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './his-select-file-metadata-icon.component.css',
} )
export class HisSelectFileMetadataIconComponent {

    /** The category to be presented. */
    readonly categoryKey = input.required<string>();

    /** The properties of that category. */
    readonly details = input.required<ResourcePropertyDetail[]>();

    private readonly displays = inject( HisResourcePropertyDisplayService );

    protected readonly display = computed( () => this.displays.iconOf( this.categoryKey() ) );

    protected readonly inputs = computed<HisResourcePropertyDisplayInputs>( () => ( { details: this.details() } ) );
}
